import { ISelectItem } from "@/types";
import { ISales } from "@/types/sales";
import {
  IOffer,
  IOfferCreateRequest,
  IOfferListRequest,
  IOfferRequest,
  IOfferUpdateRequest,
} from "@/types/offer";
import { ListRequest } from "./listRequest";
import { Sales } from "./sales";
import { ICompany } from "@/types/company";
import { Company } from "./company";
import { IPartner } from "@/types/partner";
import { Partner } from "./partner";
import { IOfferStatus } from "@/types/offerStatus";
import { OfferStatus } from "./offerStatus";
import { IMember } from "@/types/member";
import { Member } from "./member";
import { ISkill } from "@/types/skill";
import { Skill } from "./skill";
import { IPost } from "@/types/post";
import { Post } from "./post";
import { IProgress } from "@/types/progress";
import { Progress } from "./progress";
import { IProposal } from "@/types/proposal";

export class Offer implements IOffer {
  public id = 0;
  public company_id = 0;
  public partner_id = 0;
  public sales_id = 0;
  public member_id = 0;
  public offer_status_id = 0;
  public reward_lower = 0;
  public reward_upper = 0;
  public is_member_progress_finished = false;
  public is_partner_progress_finished = false;
  public title = "";
  public summary = "";
  public span_start = "";
  public span_end = "";
  public created_at = "";
  public updated_at = "";

  public company: ICompany = new Company();
  public partner: IPartner = new Partner();
  public sales: ISales = new Sales();
  public member: IMember = new Member();

  public offer_status: IOfferStatus = new OfferStatus();
  public skills: ISkill[] = [];
  public posts: IPost[] = [];
  public progress: IProgress[] = [];

  public constructor(props?: IOffer) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
    this.company = new Company(props.company);
    this.partner = new Partner(props.partner);
    this.sales = new Sales(props.sales);
    this.member = new Member(props.member);
    this.offer_status = new OfferStatus(props.offer_status);
    if (props.skills) {
      this.skills = props.skills.map((item) => new Skill(item));
    }
    if (props.posts) {
      this.posts = props.posts.map((item) => new Post(item));
    }
    if (props.progress) {
      this.progress = props.progress.map((item) => new Progress(item));
    }
  }

  public static toSelectItem(offer: IOffer): ISelectItem {
    return {
      text: offer.title,
      value: offer.id,
    };
  }
}

export class OfferRequest implements IOfferRequest {
  public partner_id = undefined;
  public member_id = 0;
  public offer_status_id = 1;
  public reward_lower = undefined;
  public reward_upper = undefined;
  public title = "";
  public span_start = "";
  public span_end = "";
  public summary = "";

  public skills: number[] = [];
  public progress: string[] = [];
  [key: string]: unknown;

  public convertFromProposal(props: IProposal) {
    Object.assign(this, props);
    if (props.members.length === 1) {
      this.member_id = props.members[0].id;
    }
    if (props.skills) {
      this.skills = props.skills.map((item) => item.id);
    }
  }
}

export class OfferCreateRequest
  extends OfferRequest
  implements IOfferCreateRequest {}

export class OfferUpdateRequest
  extends OfferRequest
  implements IOfferUpdateRequest
{
  public constructor(props?: IOffer) {
    super();

    if (!props) {
      return;
    }
    Object.assign(this, props);
    if (props.progress) {
      this.progress = props.progress.map((item) => item.name);
    }
    if (props.skills) {
      this.skills = props.skills.map((item) => item.id);
    }
  }
}

export class OfferListRequest extends ListRequest implements IOfferListRequest {
  public status?: number;
  public inprogress = false;
}
